import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { AncSuntimesYearlyComponent } from 'src/app/components/anc-suntimes-yearly/anc-suntimes-yearly.component';

@Component({
    selector: 'app-modal-anc-suntimes-yearly',
    imports: [CommonModule, TranslateModule, AncSuntimesYearlyComponent],
    templateUrl: './modal-anc-suntimes-yearly.component.html'
})
export class ModalAncSuntimesYearlyComponent {
  @Input() serial = '';

  constructor(public activeModal: NgbActiveModal) {}

  close(): void {
    this.activeModal.dismiss();
  }
}
